import React from 'react';
import { MoveUpRight } from 'lucide-react';

const DesireTechSection = ({ title, subtitle, buttonText, variant }) => {
  return (
    <section className="desire-tech-section">
      <div className="desire-tech-container">
        <h2 className="desire-tech-title">
          {title || <><span style={{ color: '#54b248' }}>Ready for a quote</span> on your BIM project?</>}
        </h2>
        <p className="desire-tech-subtitle">
          {subtitle || "Contact our sales team today for a free quote on your industry-related architecture BIM project."}
        </p>
        <button className={`desire-tech-btn ${variant === 'contactus' ? 'white-btn' : ''}`}>
          {buttonText || "Contact us With a Tech Expert"}
          {variant === 'contactus' && <MoveUpRight size={20} />}
        </button>
      </div>
    </section>
  );
};

export default DesireTechSection;
